import { normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["overlay", `state-${_ctx.state}`]),
      onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.onCloseByOutsideClick && _ctx.onCloseByOutsideClick(...args))),
      style: _normalizeStyle({ zIndex: _ctx.modal.index ? _ctx.modal.index - 1 : 1 })
    }, null, 6),
    _createElementVNode("div", {
      class: _normalizeClass(`modal-center-screen-page ${_ctx.modal.name} state-${_ctx.state}`),
      style: _normalizeStyle({ zIndex: _ctx.modal.index }),
      onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => (_ctx.onCloseByOutsideClick && _ctx.onCloseByOutsideClick(...args)), ["self"]))
    }, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.dynamicComponent), _normalizeProps(_guardReactiveProps({ onClose: _ctx.onClose, ..._ctx.modal.props })), null, 16))
    ], 6)
  ], 64))
}